import { SignupRequestError } from '../services/signup-api/signup-api';

/** How many times a transient finalize failure is retried before the member is asked. */
export const FINALIZE_MAX_RETRIES = 3;

/**
 * Only a failure that can clear on its own is retried: a dropped connection or
 * a server error. Anything else (a refused request, a signed-out member, a
 * response the client cannot read) fails the same way every time, so the
 * member is asked straight away instead of waiting through retries.
 */
export function isTransientFinalizeFailure(error: unknown): boolean {
  if (!(error instanceof SignupRequestError)) return false;
  if (error.kind === 'network') return true;
  return error.httpStatus !== undefined && error.httpStatus >= 500;
}

/** Whether a failed finalize gets another automatic try. */
export function shouldRetryFinalize(failureCount: number, error: unknown): boolean {
  return failureCount < FINALIZE_MAX_RETRIES && isTransientFinalizeFailure(error);
}

/** The wait before retry `attempt` (0 is the first retry): one, two, then four seconds. */
export function finalizeRetryDelay(attempt: number): number {
  return 1000 * 2 ** attempt;
}

/** The server's answer when the session was already finalized by an earlier, unseen request. */
export function isAlreadyFinalized(error: unknown): boolean {
  return (
    error instanceof SignupRequestError &&
    error.httpStatus === 409 &&
    error.code === 'session_completed'
  );
}
